module.exports = __webpack_public_path__ + "img/電気回路_5_7_1.ddd9b232.png";